/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * ViewModel surface for the Feature Activation Framework. Re-exports the
 * `Feature` and `FeatureStage` enums (from the model layer) so Views can pass
 * features to `selectIsFeatureEnabled`, and render the debug screen's stage
 * choices, without importing `src/model` directly.
 */

export { selectIsFeatureEnabled } from "./featureActivation.selectors";
export { selectHasLoadedDeviceFeatures } from "../postSigninStartup";
export {
  Feature,
  FeatureStage,
  OVERRIDABLE_FEATURE_STAGES
} from "../../model/featureActivation";
